import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

/**
 * Renders the editable "SEO text block" used at the bottom of Home, Entreprise,
 * Métiers. Props : { title, sections, ctaLinks=true }.
 * Renders nothing if both title and sections are empty.
 */
export const SeoBlock = ({ title, sections, ctaLinks = true }) => {
  const list = sections || [];
  if (!title && list.length === 0) return null;
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 prose prose-sm md:prose-base prose-neutral">
        {title && (
          <Reveal>
            <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight mb-6">{title}</h2>
          </Reveal>
        )}
        {list.map((s, i) => (
          <Reveal key={i} delay={Math.min(i * 60, 240)}>
            {s.title && s.level !== "intro" && (
              <h3 className="font-display text-lg md:text-xl font-bold mt-8 mb-3">{s.title}</h3>
            )}
            {s.body && (
              <p className="text-gray-700 leading-relaxed mb-4 whitespace-pre-line">{s.body}</p>
            )}
          </Reveal>
        ))}
        {ctaLinks && (
          <Reveal>
            <p className="text-sm text-gray-500 mt-6">
              <Link to="/realisations" className="text-[#E60000] underline-offset-2 hover:underline">Découvrir nos réalisations</Link>
              {" · "}
              <Link to="/contact" className="text-[#E60000] underline-offset-2 hover:underline">Nous contacter</Link>
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
};

export default SeoBlock;
